<i18n>
{
  "kr": {
"What happens to my data when the service is suddenly shut down?":"갑자기 서비스가 종료되면 내 데이터는 어떻게 되나요?",
"There are no plans to terminate the service at least within four to five years.":"적어도 4~5년 이내에는 서비스를 종료할 계획이 없습니다.",
"We'll provide tools to secure all your data, even if it's truly an inevitable shutdown.":"정말 불가피하게 서비스가 종료된 상황을 가정하더라도, 모든 유저분들이 데이터를 안전하게 확보할수 있도록 도구를 마련해드리겠습니다.",
"In addition, all data has replicas on every sync machine of the user, so no data is lost.":"아울러, 모든 데이터는 유저분의 모든 동기화 머신에 복제본이 존재하므로 데이터를 잃어버리는 경우는 없습니다.",

"Is this a reliable service?":"믿을수 있는 서비스인가요?",
"Synapbook is a powerful knowledge management system used by nearly tens of thousands of users around the world, with its development beginning six years ago, and its official open service almost three years after its official launch.":"Synapbook은 개인용 메모 관리시스템으로 개발이 시작된지 6년, 베타서비스를 거쳐서 정식 오픈 서비스가 개시된지 3년이 다 되어가는 전세계 수만명에 가까운 유저들이 이용중인 강력한 지식 관리 시스템입니다.",
"It's a proven system for safety and robustness. You can use it with confidence.":"안전성과 강력함이 검정된 시스템입니다. 안심하고 이용하셔도 됩니다.",

"Can my data be accessed by the administrator?":"내 자료를 관리자가 열람할 수 있나요?",
"Access to the Synapbook Product DB is strictly limited. Development only takes place on test DB.":"Synapbook 제품DB 열람 권한은 엄격하게 제한됩니다. 개발은 test DB상에서 이뤄집니다.",
"When data of the product DB needs to be analyzed,": "제품DB의 모든 유저분들의 데이터는 불가피하게 문제가 발생하여 분석이 필요한 경우에,",
"We will only be able to access it if you agree to it.":" 유저분이 동의해주신 경우에만 접근을 하게 됩니다.",

"What should I do if there is a bug or improvement?":"버그나 개선 요청사항이 생기면 어떻게 해야하나요?",
"Please refer to the Support page and send your suggestions to inertry@gmail.com I'll respond sincerely.":"Support 페이지를 참고하여 inertry@gmail.com로 제안사항을 보내주세요. 성실히 대응해드리겠습니다.",

"I'm curious about the roadmap for product improvement.":"제품 개선 로드맵이 궁금합니다.",
"The development roadmap page is being prepared on the homepage.":"홈페이지에 개발 로드맵 페이지를 준비중입니다.",
    "__END__":""
  }

}
</i18n>

<template>
  <div>
    <h1>FAQ</h1>
    <br>
    <b-container mg="*" class="left">
      <b-row class="margin-item">
        <b-col>
          <h4>{{$t("What happens to my data when the service is suddenly shut down")}}</h4>
          <span
            v-html="$t('There are no plans to terminate the service at least within four to five years.')"
          />
          <br>
          <span
            v-html="$t('We\'ll provide tools to secure all your data, even if it\'s truly an inevitable shutdown.')"
          />
          <span
            v-html="$t('In addition, all data has replicas on every sync machine of the user, so no data is lost.')"
          />
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <h4>{{$t("Is this a reliable service?")}}</h4>
          <span
            v-html="$t('Synapbook is a powerful knowledge management system used by nearly tens of thousands of users around the world, with its development beginning six years ago, and its official open service almost three years after its official launch.')"
          />
          <br>
          <span
            v-html="$t('It\'s a proven system for safety and robustness. You can use it with confidence.')"
          />
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <h4>{{$t("Can my data be accessed by the administrator?")}}</h4>
          <span
            v-html="$t('Access to the Synapbook Product DB is strictly limited. Development only takes place on test DB.')"
          />
          <br>
          <span v-html="$t('When data of the product DB needs to be analyzed,')"/>
          <span v-html="$t('We will only be able to access it if you agree to it.')"/>
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <h4>{{$t("What should I do if there is a bug or improvement?")}}</h4>
          <span
            v-html="$t('Please refer to the Support page and send your suggestions to inertry@gmail.com I\'ll respond sincerely.')"
          />
          <br>
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <h4>{{$t("I'm curious about the roadmap for product improvement.")}}</h4>
          <span v-html="$t('The development roadmap page is being prepared on the homepage.')"/>
          <br>
        </b-col>
      </b-row>
    </b-container>Thanks.
  </div>
</template>

<script>
export default {
  name: "support-page"
};
</script>

<style lang="css" scoped>
.counter-number {
  font-size: 40px;
}

.left {
  text-align: left;
}
.margin-item {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/FaqPage.vue